<template>
  <div id="login_wrapper">
    <!--左侧登录界面-->
    <div class="left">
      <div class="title"><span class="pless-login">请登录</span><span class="pless-right">已注册用户从这里登录</span></div>
      <Form
        ref="formInline"
        :model="login"
        :rules="ruleInline"
        :label-width="80"
      >
        <FormItem
          prop="user"
          label="账号："
        >
          <Input
            type="text"
            v-model="login.user"
            @input="fastInput"
            style="width:220px;float:left;"
            placeholder="请输入账号"
          />

        </FormItem>
        <FormItem
          prop="password"
          label="密码："
        >
          <Input
            type="password"
            v-model="login.password"
            style="width:220px;float:left;"
            placeholder="请输入密码"
          />

        </FormItem>
        <FormItem
          prop="valCode"
          label="验证码："
        >
          <Input
            type="text"
            v-model="login.valCode"
            @keyup.enter.native="Login()"
            style="width:100px;float:left;"
            placeholder="请输入验证码"
          />

          <div
            class="img-valifyCode"
            title="会员登录验证码"
            @click="createCode"
          >{{imgSrc}}</div>
          <div
            class="m_forget"
            style="cursor:pointer;"
            @click="createCode"
          >看不清楚？换个图片</div>
        </FormItem>
        <FormItem style="margin-top:40px;">
          <Button
            @click="Login()"
            type="error"
            size="large"
            style="width:120px;background-color:#d93600"
          >登 录</Button>
          <router-link
            to="/register"
            title="免费注册"
            class="reg-btn"
          >免费注册</router-link>
        </FormItem>
      </Form>
    </div>
    <!--左侧登录界面结束-->
    <!--中间竖线-->
    <!-- <div class="middle"></div> -->
    <!--中间竖线结束-->
    <!--右侧宣传-->
    <!-- <div class="right">
      <img
        src="../../assets/images/login-bg.png"
        class="pngFix"
      />
    </div> -->
    <!--右侧宣传结束-->
  </div>
</template>
<script>
import { MOBILE_REG } from "utils/url";
import { loginNew } from "api/user";
import { track } from "api/goods";
import { setSession } from "utils/tool";
import encrypt from "encryptlong";
import moment from "moment";
export default {
  data() {
    return {
      login: {
        user: "",
        password: "",
        valCode: "",
      },
      regUrl: MOBILE_REG,
      imgSrc: "",
      ruleInline: {
        user: [{ required: true, message: "此项为必填", trigger: "blur" }],
        password: [{ required: true, message: "此项为必填", trigger: "blur" }],
        valCode: [{ required: true, message: "此项为必填", trigger: "blur" }],
      },
    };
  },
  created() {
    console.log(this.$route.path, "路由地址");
    this.createCode();
  },
  methods: {
    fastInput(e) {
      this.$nextTick(() => {
        this.login.user = e.replace(/[\W]/g, ""); // 多个空格保留一个空格
      });
    },
    // 登录
    Login() {
      if (this.login.user.trim() === "") {
        this.$Message.warning("请输入账号");
        return;
      }
      if (this.login.password.trim() === "") {
        this.$Message.warning("请输入密码");
        return;
      }
      if (this.login.valCode.trim() === "") {
        this.$Message.warning("请输入验证码");
        return;
      }
      if (this.login.valCode.length !== 8) {
        if (this.login.valCode.toLowerCase() != this.imgSrc.toLowerCase()) {
          this.$Message.error("验证码错误");
          return;
        }
      }
      let users = {
        loginName: this.login.user.trim(),
        password: this.login.password.trim(),
      };
      const publicKey = process.env.PUBLICKEY;
      let encryptor = new encrypt();
      encryptor.setPublicKey(publicKey);
      let postBody = encryptor.encryptLong(JSON.stringify(users));

      this.$Loading.start();
      // this.loginNew(users);
      this.$store
        .dispatch("loginSystem", postBody)
        .then((resp) => {
          this.$Loading.finish();

          if (resp.resCode === 0 || resp.data === null) {
            this.$Message.error(resp.resDesc);
          } else {
            console.log(resp)
            let data = {
              userBehaviorsLogDTOList: [
                {
                  operationObject: 3,
                  operationPage: "登录页",
                  operationStatus: 1,
                  operationType: 1,
                  username: resp.data.loginName,
                  operationLocation: 1,
                  operationApi: "",
                  deviceType: 1,
                  deviceSystem: 1,
                  failureReason: "",
                  browser: window.navigator.appCodeName,
                  deviceVersion: window.navigator.platform,
                  startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                  endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                },
              ],
            };
            track(data).then((res) => {});
            // 登录成功后获取用户登录状态
            this.$store.dispatch("getSigned");
            //登录成功后获取用户抽奖机会
            //this.$store.dispatch('getLucky');
            // 登录成功后获取用户购物车数据
            this.$store.dispatch("getCartList");
            //判断登录前页面并跳转
            var strCookie = document.cookie;
            var arrCookie = strCookie.split("; ");
            for (var i = 0; i < arrCookie.length; i++) {
              var arr = arrCookie[i].split("=");
              if (arr[0] == "loginReferrer" && arr[1] != "") {
                document.cookie = "loginReferrer=; path=/";
                this.$router.push({ path: unescape(arr[1]) });
                return;
              }
            }
            this.$router.push({ path: "/" });
          }
        })
        .catch(() => {
          this.$Loading.error();
          //          this.$Message.error(err)
        });
      this.createCode();
    },

    loginNew(data) {
      let str = this.$Rsa.encrypt(JSON.stringify(data));
      console.log(str, "入参加密-----");
      loginNew(str).then((res) => {
        if (res.resCode == 1) {
          // console.log(this.$Rsa.decrypt(res.data), "res.data----------");
        }
      });
    },
    // 图片验证码
    createCode() {
      let code = "";
      var codeLength = 4; //验证码的长度
      var random = new Array(
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ); //随机数
      for (var i = 0; i < codeLength; i++) {
        //循环操作
        var index = Math.floor(Math.random() * 62); //取得随机数的索引（0~61）
        code += random[index]; //根据索引取得随机数加到code上
      }
      this.imgSrc = code; //把code值赋给验证码
      //todo 测试用
      //        this.login.valCode = code;
    },
    // 忘记密码
    forgetHandle() {
      this.$router.push("/forget");
    },
  },
};
</script>



// WEBPACK FOOTER //
// login.vue?07f11d88